import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationItem } from 'src/app/providers/notification-hub/notification-hub.service';
import { NotificationAttachment } from 'src/app/shared/models/notification-attachment.model';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent {
  @Input() item!: NotificationItem;
  @Input() variant: 'navbar' | 'page' = 'page';
  @Input() attachments: NotificationAttachment[] = [];
  @Input() categoryLabel = '';
  @Input() categoryIconName = 'bell';
  @Input() priorityLabel = '';
  @Input() relativeTimeLabel = '';

  @Output() cardClick = new EventEmitter<void>();
  @Output() markReadClick = new EventEmitter<Event>();
  @Output() previewAttachment = new EventEmitter<NotificationAttachment>();
  @Output() downloadAttachment = new EventEmitter<NotificationAttachment>();

  messageExpanded = false;

  get maxMessageLines(): number {
    return this.variant === 'navbar' ? 2 : 3;
  }

  get hasAttachments(): boolean {
    return this.attachments.length > 0;
  }

  onCardClick(): void {
    this.cardClick.emit();
  }

  onMarkRead(event: Event): void {
    this.markReadClick.emit(event);
  }

  onPreviewAttachment(attachment: NotificationAttachment): void {
    this.previewAttachment.emit(attachment);
  }

  onDownloadAttachment(attachment: NotificationAttachment): void {
    this.downloadAttachment.emit(attachment);
  }
}
